import React from 'react'
import {useTranslation} from 'react-i18next'

import {Avatar, Stack, Typography} from '@mui/material'

import {ReactComponent as Checkmark} from '@progyny/assets/images/checkmark.svg'
import ContactSupport from '@progyny/components/ContactSupport'

const AcceptedAgreement = () => {
  const {t} = useTranslation()
  return (
    <>
      <Stack mt={10} alignItems={'center'} justifyContent={'center'}>
        <Avatar
          sx={{
            width: 110,
            height: 110,
            bgcolor: '#EEEEF1',
            position: 'relative',
            mb: 4,
          }}
        >
          <Checkmark />
        </Avatar>
        <Typography mt={4} fontSize={24} fontWeight={600}>
          {t('partners_agreement_accepted_agreement_thank_you_for_confirming')}
        </Typography>
        <Typography my={2} fontSize={18} fontWeight={400}>
          {t(
            'partners_agreement_accepted_agreement_we_ve_received_your_confirmation'
          )}
        </Typography>
        <Typography
          textAlign={'center'}
          width={'29%'}
          fontSize={18}
          fontWeight={400}
        >
          {t(
            'partners_agreement_accepted_agreement_you_re_now_officially_part'
          )}
        </Typography>
      </Stack>
      <ContactSupport
        textKey='budget_partner_agreement_helpers_support_if_you_have_any_questions'
        px='6rem'
        mt={16}
      />
    </>
  )
}

export default AcceptedAgreement
